export const PRICING = {
    INDIA: {
      DEFAULT: '4999',
    },
  };